import { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { Leaf, Loader2 } from "lucide-react";
import { useAuth, fmtErr } from "@/context/AuthContext";

export default function Signup() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/account";
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await register(form);
      nav(next);
    } catch (e2) {
      setErr(fmtErr(e2.response?.data?.detail, "Could not create account"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="signup-page" className="mx-auto flex min-h-[70vh] max-w-md flex-col justify-center px-5 py-16">
      <img src="/logo-bins-plus.png" alt="Bins Plus Pressure Washing" className="h-14 w-14 object-contain" />
      <h1 className="mt-5 font-heading text-3xl font-extrabold tracking-tight">Create your account</h1>
      <p className="mt-2 text-muted-foreground">Manage subscriptions, rebook in one tap, and earn free visits.</p>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <input data-testid="signup-name" required placeholder="Full name" value={form.name} onChange={set("name")}
          className="w-full rounded-xl border border-border bg-muted/50 px-4 py-3 focus:bg-card focus:outline-none focus:ring-2 focus:ring-primary" />
        <input data-testid="signup-email" type="email" required placeholder="Email" value={form.email} onChange={set("email")}
          className="w-full rounded-xl border border-border bg-muted/50 px-4 py-3 focus:bg-card focus:outline-none focus:ring-2 focus:ring-primary" />
        <input data-testid="signup-phone" placeholder="Phone (optional)" value={form.phone} onChange={set("phone")}
          className="w-full rounded-xl border border-border bg-muted/50 px-4 py-3 focus:bg-card focus:outline-none focus:ring-2 focus:ring-primary" />
        <input data-testid="signup-password" type="password" required placeholder="Password (min 6 chars)" value={form.password} onChange={set("password")}
          className="w-full rounded-xl border border-border bg-muted/50 px-4 py-3 focus:bg-card focus:outline-none focus:ring-2 focus:ring-primary" />
        {err && <p data-testid="signup-error" className="text-sm font-semibold text-destructive">{err}</p>}
        <button data-testid="signup-submit" type="submit" disabled={busy}
          className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-primary px-7 py-3.5 font-bold text-primary-foreground transition-all hover:brightness-110 disabled:opacity-50">
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Create Account"}
        </button>
      </form>
      <p className="mt-6 text-center text-sm text-muted-foreground">
        Already have an account?{" "}
        <Link to={`/login?next=${encodeURIComponent(next)}`} className="font-semibold text-primary hover:underline">Log in</Link>
      </p>
    </div>
  );
}
